export default __webpack_public_path__ + "static/media/Cat.be570f27.jpg";